export default __webpack_public_path__ + "static/media/tactical.9fc6357e.svg";